import { render } from "./AddConference.vue?vue&type=template&id=d2c249b6"
import script from "./AddConference.vue?vue&type=script&lang=js"
export * from "./AddConference.vue?vue&type=script&lang=js"
script.render = render

export default script